import React, { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

/** คลาส input/select ในแถวตัวกรอง — หน้าตาเดียวกับช่องวันที่ของ UiFilterPanel */
export const FILTER_INPUT_CLASS =
  'w-full px-3 py-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-200 dark:focus:ring-slate-600 focus:border-gray-400 dark:focus:border-slate-500';

interface UiFilterFieldProps {
  label: ReactNode;
  /** ไอคอนหน้า label */
  icon?: IconDefinition;
  /** คลาสของ wrapper — ใช้กำหนดความกว้างในแถว เช่น "flex-1 min-w-[180px]" */
  className?: string;
  children: ReactNode;
}

/**
 * ช่องตัวกรอง 1 ช่องใน UiFilterPanel: label เล็กสีเทา (มีไอคอนได้) + control ด้านล่าง
 * ใช้ครอบ <select className={FILTER_INPUT_CLASS}>, checkbox group, MerchantMultiSelect ฯลฯ
 */
const UiFilterField: React.FC<UiFilterFieldProps> = ({ label, icon, className = '', children }) => (
  <div className={className}>
    <label className="block text-xs font-medium text-gray-500 dark:text-slate-400 mb-1">
      {icon && <FontAwesomeIcon icon={icon} className="mr-1" />}
      {label}
    </label>
    {children}
  </div>
);

export default UiFilterField;
